import styled from 'styled-components';

export const Container = styled.div`
  & .hefesto-icon {
    width: 1rem;
  }
`;
